export default __webpack_public_path__ + "static/media/DesolderingImg.ab35f2af.jpg";